import { ReactNode } from 'react';

export const AffiliateConsolePage = ({
  children,
}: Readonly<{ children: ReactNode }>) => (
  <main className="flex h-screen min-w-0 flex-col py-md pr-md">
    <div className="flex min-h-0 flex-1 flex-col overflow-clip rounded-xl border border-border-secondary bg-bg-primary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)]">
      {children}
    </div>
  </main>
);
